import type { Authentication } from '@barboxx/models/types';

import { api } from '../api';
import { throwIfBadResponse } from '../utils';

const rootPath = 'images';
const imageKitPath = `${rootPath}/imageKit`;

export function getImageKitToken() {
    return throwIfBadResponse(
        api.get<Authentication.ImageKitReturn>(`${imageKitPath}/token`)
    );
}
